import { getInletMetadata } from 'aem-libs-react-ts/src/inlet/getInletMetadata'

const pathHeader = 'x-path'
const inletVersionHeader = 'x-inlet-version'
const inletNameHeader = 'x-inlet-name'

const { version, name } = getInletMetadata()

export const resolveInletHeaders = (): Record<string, string> => ({
  [pathHeader]: window.location.href,
  [inletVersionHeader]: version,
  [inletNameHeader]: name
})
